import { Navigate, Outlet } from 'react-router';

import { useUser } from '@/components/auth-provider';

export function PrivateRoute() {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
